import type { Components } from '@mui/material/styles';

export default function MUIIcon(): Components['MuiIcon'] {
  return {};
}
